export enum SubscriptionStatusEnum {
  PAYMENT_PENDING = 'Boleto não gerado',
  PAYMENT_APROVED = 'Pagamento aprovado',
  CANCELED = 'Cancelada',
  WAITING_PAYMENT_SLIP = 'Aguardando geração do boleto',
  INVOICE_GENERATED='Pagamento pendente'
}